import React from 'react'
import { Box } from '@chakra-ui/react'

const Corner = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <use href={`#Corner`} />
    </svg>
  )
}

interface CornerBorderProps {
  className?: string
  children?: React.ReactNode
  color?: string
}

const CornerBorder: React.FC<CornerBorderProps> = ({
  className,
  children,
  color = 'currentColor',
}) => {
  return (
    <Box position="relative" width="100%" height="100%" className={className}>
      <Box position="absolute" top="0" left="0" color={color}>
        <Corner />
      </Box>
      <Box position="absolute" top="0" right="0" transform="rotate(90deg)" color={color}>
        <Corner />
      </Box>
      <Box position="absolute" bottom="0" left="0" transform="rotate(-90deg)" color={color}>
        <Corner />
      </Box>
      <Box position="absolute" bottom="0" right="0" transform="rotate(180deg)" color={color}>
        <Corner />
      </Box>
      {children}
    </Box>
  )
}

export default CornerBorder
